import { HttpClient } from '@angular/common/http'
import { Injectable, inject } from '@angular/core'
import { EmailResponse } from '@interfaces'
import { Observable } from 'rxjs'
import { MailSubprocessEnum } from '../enums/MailSubprocess.enum'

@Injectable({ providedIn: 'root' })
export class MailService {
	private http = inject(HttpClient)
	url = '/mail'

	sendEmail(to: string, subprocess: MailSubprocessEnum, variables?: { [key: string]: any }): Observable<EmailResponse> {
		const url = `${this.url}/send`
		return this.http.post<EmailResponse>(url, { to, subprocess, variables })
	}

	sendEmailVerification(subscriberEmail: string): Observable<void> {
		const url = `${this.url}/subscriber-verification`
		const body = {
			email: subscriberEmail
		}

		return this.http.post<void>(url, body)
	}
}
